
export default {
  props: {
    block: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    paymentMethods () {
      return this.block.payment_method_type === `season` ? this.$store.state.config.payment_methods : this.$store.state.config.match_payment_methods;
    },
  },
};
